import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateOrder } from "../../api/apiOrders";
import parseError from "../../utils/parseError";

export const useUpdateOrder = () => {
    const queryClient = useQueryClient();

    const { mutate: updateOrderMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateOrder(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Order updated successfully");
            queryClient.invalidateQueries(["orders"]);
            queryClient.invalidateQueries(["order"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update order");
        },
    });

    return { updateOrderMutate, isUpdating };
};
